import styled from "styled-components";

export const RecieveMoneyContainer = styled.div`
  width: 100%;
  height: 688px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f7f7f7;
  gap: 60px;
  padding-top: 50px;
  padding-left: 50px;
  /* border: 2px solid blue; */
  box-sizing: border-box;

  @media screen and (max-width: 2560px) {
    width: 100%;
    /* height: 993px; */
    /* display: flex; */
    /* padding: 60px 115px 86px 70px; */
    /* padding-left: 0px; */
    /* flex-direction: column;
    align-items: center; */
    gap: 50px;
    /* background: var(--General-Background, #f7f7f7); */
  }
  @media screen and (max-width: 1440px) {
    gap: 30px;
  }
  @media screen and (max-width: 1024px) {
    width: 100%;
    height: 1093px;
    display: flex;
    /* padding: 60px 115px 86px 70px; */
    padding-left: 0px;
    flex-direction: column;
    align-items: center;
    gap: 60px;
    background: var(--General-Background, #f7f7f7);
  }
  @media screen and (max-width: 768px) {
    width: 768px;
    height: 1093px;
    display: flex;
    /* padding: 60px 115px 86px 70px; */
    padding-left: 0px;
    flex-direction: column;
    align-items: center;
    gap: 60px;
    background: var(--General-Background, #f7f7f7);
  }
  @media screen and (max-width: 430px) {
    width: 100%;
    height: 927px;
    background: var(--General-Background, #f7f7f7);
    align-items: center;
    justify-content: center;
  }
  @media screen and (max-width: 375px) {
    width: 370px;
    height: 927px;
    background: var(--General-Background, #f7f7f7);
    align-items: center;
    justify-content: center;
  }
  @media screen and (max-width: 320px) {
    width: 100%;
    height: 927px;
    background: var(--General-Background, #f7f7f7);
    align-items: center;
    justify-content: center;
  }
`;
